'use client';
import { RecipeMetaSectionProps } from '@repo/ui/src/types';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { RecipeTimeProps } from '@views/RecipeDetailPage/_RecipeHero';

interface Props {
  recipeMetaSection: RecipeMetaSectionProps;
  _testID: string;
  prepTime: Array<RecipeTimeProps>;
  cookTime: Array<RecipeTimeProps>;
}

const RecipeCardInfo = ({ recipeMetaSection, _testID, prepTime, cookTime }: Props) => {
  const { t } = useTranslation();

  return (
    <div data-test-id={`recipe_cook_data_${_testID}`} className="border border-warm-400 rounded">
      <div className="grid bg-white justify-center items-center text-center py-6 lg:px-4 rounded px-4 grid-cols-[repeat(auto-fit,minmax(0,1fr))] gap-x-2">
        {!!prepTime?.length && (
          <div className="flex flex-col items-center border-r last:border-r-0 pr-2 last:pr-0">
            <p className="tra-text-web-body-m mb-0">{t('recipeContent.prepTimeLabel')}</p>
            <div className="grid grid-flow-col gap-2">
              {prepTime?.map(({ label, value }, i) => (
                <h5 className="tra-text-web-heading-5" key={i}>
                  {value} {label}{' '}
                </h5>
              ))}
            </div>
          </div>
        )}

        {!!cookTime?.length && (
          <div className="flex flex-col items-center border-r last:border-r-0 pr-2 last:pr-0">
            <p className="tra-text-web-body-m mb-0">{t('recipeContent.cookTimeLabel')}</p>
            <div className="flex flex-wrap gap-x-2 justify-center">
              {cookTime?.map(({ label, value }, i) => (
                <h5 className="tra-text-web-heading-5" key={i}>
                  {value} {label}{' '}
                </h5>
              ))}
            </div>
          </div>
        )}

        {recipeMetaSection?.hardwood && (
          <div className="flex flex-col items-center">
            <p className="tra-text-web-body-m mb-0">{t('recipeContent.pelletsLabel')}</p>
            <h5 className="tra-text-web-heading-5">{recipeMetaSection?.hardwood}</h5>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeCardInfo;
